import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import { SortableTh, sortRows, nextSort } from '../common/sortable-th';

export class Block_User_SimultaneousIPs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataCateg: [],
            results: [],
            filter: '',
            temp: [],
            page: 1,
            sort: { key: null, dir: 'asc' },
        };
        this.handleSort = this.handleSort.bind(this);
    }

    handleSort(key) {
        this.setState((prev) => ({
            sort: nextSort(prev.sort, key),
            page: 1,
        }));
    }

    componentWillMount() {
        this.getDataUser();
    }

    getDataUser(){
        var user = AuthService.getCurrentUser();
        ApiService.getBlockUserForSimultaneousIPs(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        return { 
                            Fecha: row.formatted_date,
                            ID : row.id_user, 
                            Veces: row.ip_count,
                            IP1: row.ip1_address,
                            Hora: row.ip1_time,
                            IP2: row.ip2_address,
                            'Hora 2': row.ip2_time,
                            'Nombres': row.fullname,
                        }
                    })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
                }
            },
            error => {
                const resMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            }
            );
    }

    renderPagination(total, page, pageSize, onPageChange) {
        const totalPages = Math.ceil(total / pageSize);
        if (totalPages <= 1) return null;
        const from = (page - 1) * pageSize + 1;
        const to = Math.min(page * pageSize, total);
        return (
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 16px', borderTop: '1px solid #f0f0f0',
                background: '#fafafa', fontSize: 13, color: '#666',
            }}>
                <span style={{ fontSize: 12, color: '#aaa' }}>{from}–{to} de {total}</span>
                <div style={{ display: 'flex', gap: 6 }}>
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === 1 ? '#f4f4f4' : '#fff',
                            color: page === 1 ? '#ccc' : '#333',
                            cursor: page === 1 ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-left' />
                    </button>
                    <span style={{ padding: '4px 10px', fontSize: 13, color: '#555' }}>{page} / {totalPages}</span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => onPageChange(page + 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === totalPages ? '#f4f4f4' : '#fff',
                            color: page === totalPages ? '#ccc' : '#333',
                            cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-right' />
                    </button>
                </div>
            </div>
        );
    }

    renderResults() {
        const { results, page, sort } = this.state;
        if (results.length === 0) return 'No hay datos.';

        const PAGE_SIZE = 50;
        const sorted = sortRows(results, sort);
        const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
        const currentPage = Math.min(page, totalPages);
        const paginated = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

        const headers = [
            { label: 'Fecha', key: 'Fecha' },
            { label: 'Nombres', key: 'Nombres' },
            { label: 'Veces', key: 'Veces' },
            { label: 'IP 1', key: 'IP1' },
            { label: 'Hora', key: 'Hora' },
            { label: 'IP 2', key: 'IP2' },
            { label: 'Hora 2', key: 'Hora 2' },
        ];

        return (
            <div style={{ border: '1px solid #ebebeb', borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                                {headers.map((h) => (
                                    <SortableTh key={h.key} header={h} sort={sort} onSort={this.handleSort} />
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {paginated.map((item, i) => (
                                <tr
                                    key={i}
                                    style={{ borderBottom: '1px solid #f4f4f4' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = '#f0faf4')}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = '')}
                                >
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>{item.Fecha}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                        <Link to={`${process.env.PUBLIC_URL}/customer-profile/${item.ID}`} style={{ color: '#007bff', fontWeight: 500 }}>
                                            {item.Nombres}
                                        </Link>
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                        <span style={{ background: '#fff3cd', color: '#856404', borderRadius: 10, padding: '2px 9px', fontSize: 12, fontWeight: 600 }}>
                                            {item.Veces}
                                        </span>
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>{item.IP1}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>{item.Hora}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>{item.IP2}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>{item['Hora 2']}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.renderPagination(results.length, currentPage, PAGE_SIZE, (p) => this.setState({ page: p }))}
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Seguridad" parent="Users" />
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h5>Simultáneos</h5>
                        </div>
                        <div className="card-body">
                            <div id="batchDelete">
                                {this.renderResults()}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Block_User_SimultaneousIPs;
